import { HistoryItemPeriod } from "../interfaces/historyItem";
import * as moment from "moment";
import { IntervalAndRepetition } from "../services/GAIN/IntervalAndRepetition";


export class PeriodTypeKey
{
    IntervalAndRepetition: IntervalAndRepetition = new IntervalAndRepetition("", 0, 0, HistoryItemPeriod.Min1);
    Symbol: string = "";

    public GetKey(): string
    {
        return this.IntervalAndRepetition.PeriodInterval.toString() + "_" + this.Symbol;
    }
}

export class Period
{
    PeriodType: PeriodTypeKey = new PeriodTypeKey();
    End: number = 0;

    High: number = 0;
    Low: number = 0;
    Open: number = 0;
    Close: number = 0;

    Changed: boolean = false;

    GetPeriodStart() : number
    {
        return this.End - this.PeriodType.IntervalAndRepetition.NumerOfMinutes * 60;            
    }

}

export class Quote
{
    public Symbol: string = "";
    public Bid: number = 0;
    public Ask: number = 0;
}



export class CurrentPeriods
{
    private currentPeriodsDict: { [name: string]: Period; } = {};
    private currentPerSymbolPeriodsDict: { [name: string]: { [name: string]: Period; } } = {};

    private intervals: IntervalAndRepetition[] = [];

    IntroduceNewPeriod(period: Period)
    {

        this.currentPeriodsDict[period.PeriodType.GetKey()] = period;

        if (!this.currentPerSymbolPeriodsDict[period.PeriodType.Symbol])
        {
            var perSymbolDict: { [name: string]: Period; } = {};

            this.currentPerSymbolPeriodsDict[period.PeriodType.Symbol] = perSymbolDict
        }

        this.currentPerSymbolPeriodsDict[period.PeriodType.Symbol][period.PeriodType.GetKey()] = period;

    }

    Init(intervals: IntervalAndRepetition[])
    {

        this.intervals = intervals;
    }

    GetChangedPeriods(): Period[]
    {
        var res: Period[] = [];

        for (var i in this.currentPeriodsDict) {
            var period: Period = this.currentPeriodsDict[i];
            if (period.Changed)
            {
                period.Changed = false;
                res.push(period);
            }
        }

        return res;
    }

    RegisterTick(quote: Quote)
    {
        var dictPeriodsPerSymbol: { [name: string]: Period; } = this.currentPerSymbolPeriodsDict[quote.Symbol];
        var price: number = quote.Ask;

        for (var i in dictPeriodsPerSymbol) {
            var period: Period = dictPeriodsPerSymbol[i];

            var currentTimestamp: number = GetCurrentTimeStamp();

            if (period.End < currentTimestamp) {

                while (period.End < currentTimestamp)
                {
                    period.End += period.PeriodType.IntervalAndRepetition.NumerOfMinutes * 60;
                }

                period.High = price;
                period.Close = price;
                period.Low = price;
                period.Open = price;
            }
            else
            {
                period.Close = price;
                if (price > period.High)
                {
                    period.High = price;
                }

                if (price < period.Low) {
                    period.Low = price;
                }
            }

            period.Changed = true;
        }

    }




    

}

export function GetCurrentTimeStamp(): number
{
    var now: moment.Moment = moment().tz("America/New_York");
    return now.unix() + now.utcOffset() * 60;

}